import React from 'react';
import C18ComboBox02 from "../../usa/components/C18ComboBox02"
import {getParamId2,genericTypes,wsTrans,getDatapointName} from '../../usa/utils/utils';
import {getSuperUserFlags} from '../../usa/components/C18utils'
import {pInd} from '../../components/utils/paramIds'
import {dbVals,putZValue,sendArray} from '../../components/utils/http'
import {cl, globs,getTimeI,interpolateColor,constant,supportsGenericEmaTc} from '../../components/utils/utils';
import LoadingSpinner from '../../usa/components/loadingSpinner'

class GenericSensors00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      cals:[],
      units:{},
      loaded:false,
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent", this.savePageEvent)
//     this.subscribe_sideBarClicked=globs.events.subscribe("sideBarClicked", this.sideBarClicked)
//     cl(this.props)
//     cl(globs)
    this.loadInfo()
  }

  savePageEvent=(cmd)=>{
    let parms=this.loadSaveGenSensorCals(this.gwType,"save")
//     cl(parms)
//     cl(this.props)
    sendArray(parms,this.props.current.virtual).then(e=>{
      cl("save ok")
      globs.events.publish("saveOK",true)
    })
  }

  saveGenSenseUnits=async()=>{
    let {units}=this.state
    let {zoneInfo}=this.props
    let body={
      siteId:zoneInfo.siteId,
      zoneId:zoneInfo.zoneId,
      sensorUnits:units,
    }
//     cl(body)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/sensors", method: "update",
      sessionId: globs.userData.session.sessionId, body: body})
  }

  loadSaveGenSensorCals=(gwType,getSave)=>{
    var putVal=(pid,i,mult,val)=>{// add to local and db
      dbVals.z[z][240][pid+i*mult]=val
      arr.push({
        c:240,
        d:val,
        f:1,
        i:pid+i*mult,
        t:now,
        z:z,
      })
    }
    let st=this.state
    let z=+this.zuci[0]
    let cals=[]
    let ofs=[]
    let get=(getSave=="get")
    let arr=[]
    let now=getTimeI()
//     cl(gwType,getSave)
    if(gwType==1800){
      let tab=pInd[1800].controller_configuration_settings
      let fields=["Generic 1 Calibration","Generic 2 Calibration"]
      if(get){
        cals =[...Array(2)].map((a,i)=>{
          let pid=getParamId2(gwType,"configuration_unit_settings",fields[i])
          return dbVals.z[z][240][pid]||0
        })
        return cals
      }else{
        cl("saving")
        st.cals.forEach((c,i)=>{
          let pid=getParamId2(gwType,"configuration_unit_settings",fields[i])
          dbVals.z[z][240][pid]=c
          arr.push({
            c:240,
            d:c,
            f:1,
            i:pid,
            t:now,
            z:z,
          })
        })
        return arr
      }
    }else{
      let pid=+getParamId2(gwType,"pearl_gen_sens_conf","calibrate")
      let slopeId=+getParamId2(gwType,"pearl_gen_sens_conf","slope")
      let typeId=+getParamId2(gwType,"pearl_gen_sens_conf","sensorType")
      let emaTcId=+getParamId2(gwType,"pearl_gen_sens_conf","emaTc")// C20C22-4549, firmware 639
      let emaTcOk=supportsGenericEmaTc(this.zone?.gatewayId)
//       cl(slopeId)
      let tab=pInd[1900].pearl_gen_sens_conf
      let mult=tab[2]
      let cnt=tab[3]
      this.emaTcPid=(i)=>emaTcId+mult*i// for the super user hover
//       cl(pid,mult,cnt)
      if(get){// now returns an array of o,s objects
        cals =[...Array(cnt)].map((a,i)=>{
          let v={
            o:dbVals.z[z][240][pid+mult*i]||0,
            s:dbVals.z[z][240][slopeId+mult*i]||1,// multiplier: unset or 0 means 1 (no scaling)
            t:dbVals.z[z][240][typeId+mult*i]||0,
          }
// EMA TC default is 0s, or 5s for a light sensor, if the controller hasn't reported it
          let e=dbVals.z[z][240][emaTcId+mult*i]
          v.e=(e!=null)?e:((v.t==constant.GENTYPE_LGHT)?5:0)
          return v
        })
        let{zoneInfo}=this.props
//         cl(zoneInfo)
//         cl(globs.sensorsInfo.info)
        let sensors=globs.sensorsInfo.info.find(
          s=>(s.siteId==zoneInfo.siteId)&&(s.zoneId==zoneInfo.zoneId))
//         cl(sensors)
        return {cals:cals,units:sensors?.sensorUnits,emaTcOk:emaTcOk}
      }else{
        this.saveGenSenseUnits()
//         cl("saving")
        st.cals.forEach((c,i)=>{
          putVal(pid,i,mult,c.o)
          putVal(slopeId,i,mult,c.s)
          if(emaTcOk){putVal(emaTcId,i,mult,this.clampEmaTc(c.e))}
//           let pid=getParamId2(gwType,"pearl_gen_sens_conf",fields[i])
//           dbVals.z[z][240][pid+i*mult]=c.o
// //           if(i<2){
//             arr.push({
//               c:240,
//               d:c.o,
//               f:1,
//               i:pid+i*mult,
//               t:now,
//               z:z,
//             })
//           }
        })
//         cl(arr)
        return arr
//         return arr
      }
    }
  }

  loadInfo=()=>{// assume that the siteData is loaded
    this.zuci=this.props.zuci.split("-")
    this.siteId=globs.userData.session.siteId
    this.zone=globs.zonesInfo.info.filter(z=>{return (z.siteId==this.siteId)&&
      (z.siteZoneIndex==+this.zuci[0])})[0]
    this.gwType=this.zone.gatewayType||1800
//     cl(this.gwType)
//     cl(this.siteId)
//     cl(this.zone)
    this.state=this.loadSaveGenSensorCals(this.gwType,"get")
    this.state.loaded=true
//     cl(globs.sensorsInfo.info)
//     cl(this.state.cals)

  }

  clampEmaTc=(v)=>{// uint16 seconds, 0-3600
    return Math.min(3600,Math.max(0,parseInt(v,10)||0))
  }

  blockNonDigitKeys=(e)=>{// EMA TC is whole seconds: no ".", "-", "e" etc.
    if([".",",","-","+","e","E"].includes(e.key)){e.preventDefault()}
  }

  blockNonDigitPaste=(e)=>{
    if(!/^[0-9]*$/.test(e.clipboardData.getData("text").trim())){e.preventDefault()}
  }

  emaTcTitle=(i)=>{// only super users get a hover (the PID), like other FUI controls
    if((getSuperUserFlags()&constant.SUPER_PRIVS_EDIT)==0||!this.emaTcPid){return undefined}
    let pid=this.emaTcPid(i)
    return `Pid is ${pid}\n${getDatapointName(pid,1900)}\nConfig ID 639 (CTRLCFG_ID_ZONE_SETUP_GENERIC_EMA_TC)`
  }

  onChange=(type,value)=>{
    cl(type,value)
    var cals
    let st=this.state
    switch(type){
      case "units":
        globs.events.publish("savePageEnable",true)
        let units=Object.assign(st.units||{})
        if(value.val.units=="Default"){
          delete units[`e0gn${value.ind}`]
        }else{
          if(value.val.units){units[`e0gn${value.ind}`]=value.val.units}
        }
        this.setState({units:units})
        break
      case "genSlope":
      case "genOfs":
        globs.events.publish("savePageEnable",true)
        let cals=st.cals.slice(0)
        let prop=(type=="genSlope")?"s":"o"
        cals[value.ind][prop]=value.val
        this.setState({cals:cals})
        break
      case "genEmaTc":
        let val=`${value.val}`.trim()// empty while typing, else whole seconds 0-3600
        if(!/^[0-9]*$/.test(val)){break}// no decimals or negatives
        globs.events.publish("savePageEnable",true)
        let cals2=st.cals.slice(0)
        cals2[value.ind].e=(val=="")?"":this.clampEmaTc(val)
        this.setState({cals:cals2})
        break
    }
  }

  // Bare ° looks tiny; show "°degree" for default temp-style units
  fmtDefaultUnit=(u)=>{
    if(u==null||u===""){return ""}
    let s=String(u)
    if(s==="\u00B0"||s==="°"){return "\u00B0degree"}
    return s
  }

  showUnitCombo=(c,i)=>{
//     cl(this.state.units)
    let {units}=this.state
    let opts=[
      {t:"Default"},
//       {t:"Degrees"},
      {t:"\u00B0F"},
      {t:"\u00B0C"},
      {t:"% RH"},
      {t:"%"},
      {t:"Mph"},
      {t:"Volts"},
      {t:"GPM"},
      {t:"Gal"},
      {t:"uMol"},
      {t:"uMol/m2"},
      {t:"Kpa"},
      {t:"mg/Ltr"},
      {t:"uSiemens"},
    ]
//     let unit=units[`e0gn${i}`]||"Default"
    let parms={
      valueName:"units",
      default:units?.[`e0gn${i}`]||"Default",
      style:{width:150},
      opts:opts,
      onChange:(t,v)=>this.onChange("units",{ind:i,val:v}),
    }
    return(
      <div style={{display:"inline-block"}}>
      <C18ComboBox02 parms={parms}/>
      </div>
    )
  }

  showGenericSensor=(c,i)=>{
    let {units}=this.state
    let{zoneInfo}=this.props
    let type=genericTypes.filter(g=>{return g.v==(c.t||0)})[0]
//     cl(type,c)
    let sensors=globs.sensorsInfo.info.find(
      s=>(s.siteId==zoneInfo.siteId)&&(s.zoneId==zoneInfo.zoneId))
    let name=sensors?.sensorNames?.[`e0gn${i}`]||`Generic ${i+1}`
    name=name.replace("Generic Sensor","Generic")
    return(
      <div key={i}>
      <label style={{display:"inline-block",
        textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden",
        marginBottom:0,
        width:120}}>
        <span translate="no">{name}</span>{` Slope:`}</label>&nbsp;
        <input type="number" style={{width:150}}
          value={c.s}
          size="5"
          onChange={e=>this.onChange("genSlope",{ind:i,val:e.currentTarget.value})}
        />
      <label style={{display:"inline-block"}}>{`Offset:`}</label>&nbsp;
        <input type="number" style={{width:150}}
          value={c.o}
          size="5"
          onChange={e=>this.onChange("genOfs",{ind:i,val:e.currentTarget.value})}
        />
      {this.state.emaTcOk&&<>
      <label style={{display:"inline-block"}}>{`EMA TC (s):`}</label>&nbsp;
        <input type="number" style={{width:100}}
          value={c.e}
          min="0"
          max="3600"
          step="1"
          size="5"
          title={this.emaTcTitle(i)}
          onKeyDown={this.blockNonDigitKeys}
          onPaste={this.blockNonDigitPaste}
          onChange={e=>this.onChange("genEmaTc",{ind:i,val:e.currentTarget.value})}
        />
      </>}
      <label style={{display:"inline-block"}}>{`Units:`}</label>&nbsp;
        {this.showUnitCombo(c,i)}
        {!units?.[`e0gn${i}`]&&<span>{this.fmtDefaultUnit(type?.u)}</span>}
        <div className="clearfloat"/><br/>
      </div>
    )
  }

  showGenericSensors=()=>{
    let st=this.state
    let rows=st.cals.map((c,i)=>{return this.showGenericSensor(c,i)})
    return(
      <div>
      {rows}
      </div>
    )
  }

  render(){

//     cl(this.state)
    if(this.state.loaded){
      return(
      <div>
        {this.showGenericSensors()}
      </div>
      )
    }else{
      return <LoadingSpinner message="loading equipment..." />
    }
  }
}

export default GenericSensors00 ;
